


















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import clipboardCopy from '../plugins/clipboardCopy.js'

@Component
export default class ItemIdChip extends Vue {
  get privateIsShown() {
    return this.isShown && !!this.itemId.trim()
  }
  @Prop({ required: true })
  public itemId!: string
  @Prop({ default: false })
  public isShown!: boolean

  private isCopied: boolean = false
  @Watch('itemId')
  public onItemIdChanged(value: string, oldvalue: string) {
    this.isCopied = false
  }
  @Watch('isShown')
  public onPropertyChanged(value: boolean, oldvalue: boolean) {
    this.isCopied = false
  }

  private async copyItemId() {
    this.isCopied = true
    await clipboardCopy(this.itemId)
    await this.delay(3000)
    this.isCopied = false
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}
